export enum ProfileRole {
    LENDER_USER = 'LENDER_USER',
    LENDER_ADMIN = 'LENDER_ADMIN',
    CS_ADMIN = 'CS_ADMIN',
    SYSTEM_ADMIN = 'SYSTEM_ADMIN',
    REPORTING = 'REPORTING'
}
